<template>
  <div ref="observerElement">
    <video
      ref="videoElement"
      class="video-js"
      preload="auto"
      muted
      playsinline
      controls
    >
      <source
        :src="source"
        type="application/x-mpegURL"
      >
    </video>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import videojs from 'video.js'

// eslint-disable-next-line import/no-extraneous-dependencies
require('video.js/dist/video-js.css')

export default {
  props: {
    source: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      observer: null,
      showError: false, // เพิ่ม state สำหรับแสดงข้อผิดพลาด
    }
  },
  mounted() {
    this.player = videojs(this.$refs.videoElement, {}, () => {
      this.player.on('error', () => {
        this.handleError()
        this.$emit('fetch')
      })
    })
    this.setupIntersectionObserver()
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    handleError() {
      // โค้ดสำหรับจัดการเมื่อเกิดข้อผิดพลาดกับวิดีโอ
      this.showError = true // เปลี่ยน state เพื่อแสดงภาพข้อผิดพลาด
    },
    setupIntersectionObserver() {
      const options = {
        root: null, // observing with respect to viewport
        threshold: 0.5, // trigger if 50% of the player is visible
      }
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.player.play()
          } else {
            this.player.pause()
          }
        })
      }, options)
      this.observer.observe(this.$refs.observerElement)
    },
  },
}
</script>

<style scoped>
.video-js {
  width: 100%; /* Make the video fill the width of its parent */
  height: auto; /* Adjust height automatically */
  aspect-ratio: 16 / 9; /* Maintain an aspect ratio (adjust as needed) */
}
</style>
